import { render, staticRenderFns } from "./ReportsComparativePillar.vue?vue&type=template&id=2c0a1e6f&scoped=true&"
import script from "./ReportsComparativePillar.vue?vue&type=script&lang=js&"
export * from "./ReportsComparativePillar.vue?vue&type=script&lang=js&"
import style0 from "./ReportsComparativePillar.vue?vue&type=style&index=0&id=2c0a1e6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a1e6f",
  null
  
)

export default component.exports